import {
    HTTP
} from '@/utilities/http-common';
// import { stat } from 'fs';

export default {
    namespaced: true,
    state: {
        templates: [],
        newEntoCollectionModal: false,
        entoCollectionCodes: [],
        view: '',
        prefix: (['kenya', 'mali'].indexOf(process.env.VUE_APP_STUDY) >= 0) ? 'kenya' : process.env.VUE_APP_STUDY
    },
    getters: {
        getTemplateById: (state) => (id) => {
            return state.templates.find(template => template.id === id);
          },
          entoTemplates: (state) => {
            return state.templates.filter(template => template.id !== 'microscopy');
          },
          getCodes: (state) => {
            return state.entoCollectionCodes.filter(item => item.collection_code !== undefined);
          }
    },
    mutations: {
        setTemplates (state, templates) {
            state.templates = templates;
        },
        updateEntoCollectionModal (state, display) {
            state.newEntoCollectionModal = display;
        },
        setEntoCollectionCodes (state, codes) {
            state.entoCollectionCodes = codes;
        },
        updateView(state, view) {
            state.view = view;
        }
    },
    actions: {
        getTemplates({state}) {
            return HTTP.get(`/${state.prefix}/websheet/template/`);
            
        },
        setTemplates({commit}, templates) {
            commit('setTemplates', templates);
        },
        updateEntoCollectionModal({commit}, display) {
            commit('updateEntoCollectionModal', display);
        },
        setEntoCollectionCodes({commit}, codes) {
            commit('setEntoCollectionCodes', codes);
        },
        getEntoCollectionCodes({commit}, status = 'all') {
            commit;
            if (status == 'all') {
                return HTTP.get(`/${this.prefix}/collection-codes`);
            } else {
                return HTTP.get(`/${this.prefix}/collection-codes/?status=${status}`);
            }
        },
        getEntoData({commit, state}, payload) {
            commit;
            return HTTP.get(`/${state.prefix}/ento-data/${payload.collection_code}`, {
                params: {...payload}
            });
        },
        getSubjectMicroscopy({commit, state}, bloodslideDate) {
            commit;
            return HTTP.get(`/${state.prefix}/subject-microscopy?date=${bloodslideDate}`);
        },
        updateView({ commit }, view) {
            commit('updateView', view);
        }
    },
}